import { db } from './utils.mjs'
import { isManualDisconnect } from './walletLifecycle.mjs'
import { clearWalletConnectStorage } from './patchMathBigInt.mjs'
import { inferWalletKeyFromProvider } from './dapp/inject.mjs'

const APPKIT_HOST_TAGS = new Set([
  'w3m-modal',
  'appkit-modal',
  'w3m-container',
  'appkit-container',
])

function isMobileInAppWebView(ua = '') {
  const s = ua || (typeof navigator !== 'undefined' ? navigator.userAgent : '')
  return /Android|iPhone|iPad|Mobile|TokenPocket|HarmonyOS|OpenHarmony|HUAWEI|;\s*wv\)/i.test(s)
}

/** 移除 Reown AppKit / WalletConnect 弹层 DOM，避免关闭后遮罩残留导致 WebView 白屏 */
export function resetAppKitCssState(root = typeof document !== 'undefined' ? document : null) {
  if (!root?.documentElement) return
  try {
    const html = root.documentElement
    ;['--apkt-modal-width', '--apkt-footer-height', '--local-modal-padding', '--apkt-duration-dynamic'].forEach(
      (key) => html.style.removeProperty(key),
    )
    root.querySelectorAll?.('style[data-w3m="scroll-lock"]')?.forEach((el) => el.remove())
  } catch (_e) {
    void _e
  }
}

export function cleanupAppKitDom(root = typeof document !== 'undefined' ? document : null) {
  if (!root || !root.querySelectorAll) return 0
  let removed = 0
  try {
    APPKIT_HOST_TAGS.forEach((tag) => {
      root.querySelectorAll(tag).forEach((el) => {
        el.remove()
        removed += 1
      })
    })
    resetAppKitCssState(root)
    if (root.body) {
      const overflow = root.body.style?.overflow
      if (overflow === 'hidden') root.body.style.overflow = ''
      root.body.classList?.remove?.('w3m-open', 'w3m-scroll-lock', 'appkit-open')
    }
    root.documentElement?.classList?.remove?.('w3m-open', 'w3m-scroll-lock', 'appkit-open')
  } catch (_e) {
    void _e
  }
  return removed
}

/**
 * 手机 WebView 内：曾走 EVM WalletConnect（更多钱包 / 安装引导扫码）后刷新，
 * 本地残留 wallet_connect + topic 但无活跃 provider，应回落到注入钱包静默回填。
 */
export function sanitizeStaleEvmWalletConnectDb() {
  if (typeof window === 'undefined') return false
  if (isManualDisconnect()) return false
  const wt = db.get('wallet_type', 'inject')
  if (wt !== 'wallet_connect') return false
  const eth = window.ethereum || window.bitkeep?.ethereum
  if (!eth || typeof eth.request !== 'function') return false
  db.set('wallet_type', 'inject')
  db.set('topic', '')
  const savedKey = String(db.get('wallet_key', '') || '').trim()
  if (!savedKey || savedKey === 'walletConnect') {
    const inferred = inferWalletKeyFromProvider(eth)
    if (inferred) {
      db.set('wallet_key', inferred)
    }
  }
  return true
}

/**
 * 手机 WebView：无活跃 WC 会话时清理 wc@2 等缓存，避免 AppKit 初始化抛错导致白屏。
 */
export function purgeStaleWalletConnectCache() {
  if (typeof window === 'undefined') return
  const wt = db.get('wallet_type', 'inject')
  if (wt === 'wallet_connect' || wt === 'wallet_connect_tron') return
  try {
    clearWalletConnectStorage()
  } catch (_e) {
    void _e
  }
}

/** 首屏：清 AppKit 残留 + 修正 EVM WC 脏状态（不影响 Tron WC 自动恢复） */
export function sanitizeMobileWalletBoot() {
  cleanupAppKitDom()
  if (!isMobileInAppWebView()) return
  sanitizeStaleEvmWalletConnectDb()
  purgeStaleWalletConnectCache()
  try {
    document.documentElement?.classList?.add?.('hs-paint-fallback')
  } catch (_e) {
    void _e
  }
}
